import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { trim } from 'lodash';

import Modal from '../../../../components/uiComponent/modal/index';
import ReactSelect from '../../../../components/uiComponent/select';
import Input from "../../../../components/uiComponent/inputs/input/index";

import { AddressModalWrapper } from '../style'
import { UpdateAddress, CreateAddress } from '../../../../slices/address';
import { GetAllShipFromAddress } from '../../../../slices/work-orders';
import { Spin } from 'antd';

const stateOptions = [
  { value: "AL", label: "AL" },
  { value: "AK", label: "AK" },
  { value: "AZ", label: "AZ" },
  { value: "AR", label: "AR" },
  { value: "CA", label: "CA" },
  { value: "CO", label: "CO" },
  { value: "CT", label: "CT" },
  { value: "DE", label: "DE" },
  { value: "FL", label: "FL" },
  { value: "GA", label: "GA" },
  { value: "HI", label: "HI" },
  { value: "ID", label: "ID" },
  { value: "IL", label: "IL" },
  { value: "IN", label: "IN" },
  { value: "IA", label: "IA" },
  { value: "KS", label: "KS" },
  { value: "KY", label: "KY" },
  { value: "LA", label: "LA" },
  { value: "ME", label: "ME" },
  { value: "MD", label: "MD" },
  { value: "MA", label: "MA" },
  { value: "MI", label: "MI" },
  { value: "MN", label: "MN" },
  { value: "MS", label: "MS" },
  { value: "MO", label: "MO" },
  { value: "MT", label: "MT" },
  { value: "NE", label: "NE" },
  { value: "NV", label: "NV" },
  { value: "NH", label: "NH" },
  { value: "NJ", label: "NJ" },
  { value: "NM", label: "NM" },
  { value: "NY", label: "NY" },
  { value: "NC", label: "NC" },
  { value: "ND", label: "ND" },
  { value: "OH", label: "OH" },
  { value: "OK", label: "OK" },
  { value: "OR", label: "OR" },
  { value: "PA", label: "PA" },
  { value: "RI", label: "RI" },
  { value: "SC", label: "SC" },
  { value: "SD", label: "SD" },
  { value: "TN", label: "TN" },
  { value: "TX", label: "TX" },
  { value: "UT", label: "UT" },
  { value: "VT", label: "VT" },
  { value: "VA", label: "VA" },
  { value: "WA", label: "WA" },
  { value: "WV", label: "WV" },
  { value: "WI", label: "WI" },
  { value: "WY", label: "WY" },
  { value: "DC", label: "DC" },
  { value: "AS", label: "AS" },
  { value: "GU", label: "GU" },
  { value: "MP", label: "MP" },
  { value: "PR", label: "PR" },
  { value: "VI", label: "VI" },
  { value: "UM", label: "UM" },
  { value: "FM", label: "FM" },
  { value: "MH", label: "MH" },
  { value: "PW", label: "PW" },
  { value: "AA", label: "AA" },
  { value: "AE", label: "AE" },
  { value: "AP", label: "AP" }
];

const data = {
  wh_name: '',
  address_line_1: '',
  city: '',
  zipcode: '',
  state_or_province: '',
  country: 'US',
  phone: ''
};

const AddressModal = ({
  showModal,
  setShowModal,
  addressIndex,
  changeAddress,
  setAddressIndex
}) => {
  const dispatch = useDispatch();

  const [addressDetails, setAddressDetails] = useState({ previous: {}, current: {} });

  const {
    warehouseAddresses,
  } = useSelector((state) => state.workOrders || {});

  const {
    creatingAddress,
    updatingAddress,
  } = useSelector((state) => state.address || {});

  const { previous, current } = addressDetails || {};

  useEffect(() => {
    if (addressIndex !== -1) {
      const {
        wh_name,
        address_line_1,
        city,
        zipcode,
        state_or_province,
        country,
        phone,
      } = warehouseAddresses[addressIndex] || {};

      data.wh_name = wh_name || '';
      data.address_line_1 = address_line_1 || '';
      data.city = city || '';
      data.zipcode = zipcode || '';
      data.state_or_province = state_or_province || '';
      data.country = country || 'US';
      data.phone = phone || '';
      setAddressDetails({ previous: data, current: data });
    } else {
      setAddressDetails({ previous: {}, current: {} });
    }
  }, [addressIndex]);

  const handleChangeAddressDetails = ({ key, value }) => {
    setAddressDetails(addressDetails => ({
      ...addressDetails,
      current: {
        ...addressDetails?.current,
        [key]: value
      }
    }));
  };

  const getSaveBtnDisabledStatus = () => {
    if (creatingAddress || updatingAddress) return true;

    if (!trim(current?.wh_name)) return true;
    if (!trim(current?.address_line_1)) return true;
    if (!trim(current?.city)) return true;
    if (!trim(current?.zipcode)) return true;
    if (!trim(current?.state_or_province)) return true;
    if (!trim(current?.phone)) return true;

    if (addressIndex !== -1) {
      if (
        (trim(previous?.wh_name) === trim(current?.wh_name)) &&
        (trim(previous?.address_line_1) === trim(current?.address_line_1)) &&
        (trim(previous?.city) === trim(current?.city)) &&
        (trim(previous?.zipcode) === trim(current?.zipcode)) &&
        (trim(previous?.state_or_province) === trim(current?.state_or_province)) &&
        (trim(previous?.phone) === trim(current?.phone))
      ) return true;
    }

    return false;
  };

  const handleSaveAddress = () => {
    if (addressIndex !== -1) {
      dispatch(UpdateAddress({
        address: current,
        addressId: warehouseAddresses[addressIndex]?.id
      }))
        .then(({ payload }) => {
          const { success } = payload || {};
          dispatch(GetAllShipFromAddress());
          if (success) setShowModal(false);
        });
    }
    else {
      dispatch(CreateAddress({
        address: current,
      }))
        .then(({ payload }) => {
          const { success, data } = payload || {};
          dispatch(GetAllShipFromAddress());
          if (success) {
            setShowModal(false);
            changeAddress(data?.id);
          }
        });
    }
  };

  const {
    wh_name,
    address_line_1,
    city,
    zipcode,
    state_or_province,
    country,
    phone,
  } = current || {};

  return (
    <div>
      <Modal
        open={showModal}
        onClose={() => {
          setAddressIndex(-1);
          setShowModal(false);
        }}
        onHide={() => {
          setAddressIndex(-1);
          setShowModal(false);
        }}
        closeText='Cancel'
        saveText={'Submit'}
        className='address-modal-overlay-wrapper'
        removeIcon
        size="md"
        onSave={handleSaveAddress}
        buttonDisabled={getSaveBtnDisabledStatus()}
      >
        <AddressModalWrapper>
          <Spin tip='Loading...' spinning={creatingAddress || updatingAddress}>
            <h6>{`${(addressIndex === -1) ? 'Add' : 'Edit'} Address`}</h6>
            <div className='address-modal-wrapper'>
              <Input
                label="Name"
                placeholder="Enter"
                value={wh_name}
                onChange={({ target }) => handleChangeAddressDetails({ key: 'wh_name', value: target?.value })}
              />
              <Input
                label="Address"
                placeholder="Enter"
                value={address_line_1}
                onChange={({ target }) => handleChangeAddressDetails({ key: 'address_line_1', value: target?.value })}
              />
              <Input
                label="City"
                placeholder="Enter"
                value={city}
                onChange={({ target }) => handleChangeAddressDetails({ key: 'city', value: target?.value })}
              />
              <Input
                label="Postal Code"
                placeholder="Enter"
                value={zipcode}
                type='number'
                onChange={({ target }) => handleChangeAddressDetails({ key: 'zipcode', value: target?.value })}
              />
              <Input
                type="number"
                label="Phone Number"
                placeholder="Enter"
                value={phone}
                onChange={({ target }) => handleChangeAddressDetails({ key: 'phone', value: target?.value })}
              />
              <Input
                label="Country Code"
                placeholder="US"
                value={country}
                disabled={true}
                onChange={({ target }) => handleChangeAddressDetails({ key: 'country', value: target?.value })}
              />
              <ReactSelect
                options={stateOptions}
                value={state_or_province ? stateOptions.find(option => option.value === state_or_province) : null}
                label="State/Province"
                onChange={({ value }) => handleChangeAddressDetails({ key: 'state_or_province', value })}
                placeholder="Select"
              />
            </div>
          </Spin>
        </AddressModalWrapper>
      </Modal>
    </div>
  )
}

export default AddressModal
